import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function usePaymentService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getUnhandledBankPayments = () => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .PaymentClient.UnhandledBankPayments()
      .then((res) => res.data);
  };

  const approvePayments = (payments: WintSuperkollAPIModel.BankPaymentInformationPut) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .PaymentClient.SignUnhandledBankPayments(payments)
      .then((res) => res.data);
  };

  const getBankIdPayments = () => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .BankIdSignClient.GetPendingPaymentSigningInfo()
      .then((res) => res.data);
  };

  const getBankIdStatus = (bankId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .BankIdSignClient.Get(bankId)
      .then((res) => res.data);
  };

  const signBankIdPayments = (payments: WintSuperkollAPIModel.SignPaymentsPost) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .BankIdSignClient.SignPaymentsBegin(payments)
      .then((res) => res.data);
  };

  return {
    getUnhandledBankPayments,
    approvePayments,
    getBankIdPayments,
    getBankIdStatus,
    signBankIdPayments,
  };
}

export default usePaymentService;
